module.exports = __webpack_public_path__ + "img/113.language_of_the_service.288e7b79.svg";